
(() => {
  'use strict';

  const root = document.getElementById('ldx-landing');

  if (!root) {
    document.body.classList.remove('ld-landing-active');
    return;
  }

  /* Images cassées : bascule sur l'image de secours */
  root.querySelectorAll('img[data-fallback]').forEach((image) => {
    image.addEventListener('error', () => {
      const fallback = image.dataset.fallback;
      if (!fallback || image.dataset.fallbackApplied === 'true') {
        image.hidden = true;
        return;
      }
      image.dataset.fallbackApplied = 'true';
      image.src = fallback;
    });
  });

  /* Le CTA collant se cache quand le CTA final est visible */
  const sticky = root.querySelector('.ldx-sticky');
  const finalSection = document.querySelector('.ldx-final');

  if (sticky && finalSection && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      ([entry]) => { sticky.classList.toggle('is-hidden', entry.isIntersecting); },
      { threshold: 0.08 }
    );
    observer.observe(finalSection);
  }

  /* Logo du thème : on borne sa hauteur en dur, quel que soit le thème */
  const capLogo = () => {
    const head = document.querySelector(
      '#shopify-section-header, .shopify-section-group-header-group, ' +
      '.header-wrapper, .site-header, sticky-header, body > header'
    );
    if (!head) return;
    const max = window.innerWidth < 750 ? '44px' : '58px';
    head.querySelectorAll('img, svg').forEach((el) => {
      el.style.setProperty('max-height', max, 'important');
      el.style.setProperty('width', 'auto', 'important');
      el.style.setProperty('object-fit', 'contain', 'important');
    });
  };

  capLogo();
  window.addEventListener('resize', capLogo);
  window.addEventListener('load', capLogo);
  document.addEventListener('shopify:section:load', capLogo);

  /* Éditeur de thème : on nettoie la classe si le bloc est retiré */
  document.addEventListener('shopify:section:unload', () => {
    requestAnimationFrame(() => {
      if (!document.getElementById('ldx-landing')) {
        document.body.classList.remove('ld-landing-active');
      }
    });
  });

})();
